// Chakra imports
import {
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import TablesUserRow from "components/Tables/TablesUserRow";
import React from "react";

const UsersTable = ({ title, captions, data, setUserProfiles, currentUserEmail }) => {
  const textColor = useColorModeValue("gray.700", "white");
  return (
    <Card overflowX={{ base: "auto", xl: "hidden" }}>
      <CardHeader p='6px 0px 22px 0px'>
        <Text fontSize='xl' color={textColor} fontWeight='bold'>
          {title}
        </Text>
      </CardHeader>
      <CardBody>
        <Table variant='simple' color={textColor}>
          <Thead>
            <Tr my='.8rem' pl='0px' color='gray.400'>
              {captions.map((caption, idx) => {
                return (
                  <Th color='gray.400' key={idx} ps={idx === 0 ? "0px" : null}>
                    {caption}
                  </Th>
                );
              })}
            </Tr>
          </Thead>
          <Tbody>
            {data.map((row) => {
              return (
                <TablesUserRow
                  key={`${row.email}`}
                  first_name={row.first_name}
                  last_name={row.last_name}
                  logo={row.logo}
                  role={row.role}
                  email={row.email}
                  func={row.function}
                  date={row.date}
                  setUserProfiles={setUserProfiles}
                  currentUserEmail={currentUserEmail}
                />
              );
            })}
          </Tbody>
        </Table>
      </CardBody>
    </Card>
  );
};

export default UsersTable;
